<script>
import requirementModal from "../requirements/requirementModal";
import pdfUtility from "../utility/pdfUtility";
import excelUtility from "../utility/excelUtility";
export default {
  name: "requirement-table",
  components: { requirementModal, pdfUtility, excelUtility },
  props: {},
  data: function() {
    return {
      loading: true,
      page: 1,
      filter: "",
      pageData: [],
      totalItemCount: 0,
      activeItem: "",
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [true],
      },
      headers: [
        { text: "Status", value: "Status", sortable: false },
        { text: "Vessels", value: "RequirementVessels", sortable: false },
        { text: "Charterer", value: "ChartererCompanyName", sortable: false },
        { text: "Commencing", value: "DeliveryWindow", sortable: false },
        { text: "Period", value: "RequirementPeriods", sortable: false },
        { text: "Duties", value: "Duty", sortable: false },
        { text: "Brokers", value: "Brokers" },
        { text: "Offer Due", value: "OfferDueDateDisplay", sortable: false },
        { text: "Offer Count", value: "OfferCount", sortable: false },
        { text: "Released", value: "OffersReleasedToPortal", align: "center", sortable: false },
        { text: "Modified", value: "LastModified", sortable: false },
        { text: "", value: "actions", sortable: false },
      ],
      selectedRequirementId: null,
      dialogDelete: false,
      dialogSendNotification: false,
      dialogReleaseToPortal: false,
      isRetracting: false,
      showOpen: true,
      showClosed: false,
      showCancelled: false,
    };
  },
  methods: {
    async getData() {
      this.loading = true;
      var sortBy = this.options.sortBy;
      var sortDesc = this.options.sortDesc == null ? true : this.options.sortDesc;
      var parameters = {
        page: this.options.page,
        pageSize: this.options.itemsPerPage,
        filter: this.filter,
        sortBy: sortBy,
        sortDesc: sortDesc,
        showOpen: this.showOpen,
        showClosed: this.showClosed,
        showCancelled: this.showCancelled,
      };

      var response = await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "GetRequirementsSummary",
        parameters: parameters,
      });
      this.totalItemCount = response.Item1;
      this.pageData = response.Item2;
      this.loading = false;
    },
    onRowEdit: function(item) {
      this.$store.commit("setActiveRequirementModal", { visible: true, id: item.RequirementId });
    },
    onRowDelete: function(item) {
      this.selectedRequirementId = item.RequirementId;
      this.dialogDelete = true;
    },
    onCloseModal() {
      this.dialogReleaseToPortal = false;
      this.dialogDelete = false;
      this.dialogSendNotification = false;
      this.selectedRequirementId = null;
    },
    async onConfirmRowDelete() {
      await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "DeleteRequirement",
        parameters: { id: this.selectedRequirementId },
      });
      this.onCloseModal();
    },
    onRowClick(item) {
      this.$store.commit("setActiveRequirementId", item.RequirementId);
    },
    onAddNew() {
      this.$store.commit("setActiveRequirementModal", { visible: true, id: null });
    },
    getItemClass(item) {
      if (item.RequirementId == this.activeRequirementId) {
        return "active";
      } else {
        return "not-active";
      }
    },
    onReleaseToPortalClick(item) {
      this.selectedRequirementId = item.RequirementId;
      this.isRetracting = item.OffersReleasedToPortal;
      this.dialogReleaseToPortal = true;
    },
    onSendNotificationClick(item) {
      this.dialogSendNotification = true;
      this.selectedRequirementId = item.RequirementId;
    },
    async onConfirmSendNotification() {
      await this.$store.dispatch("getRequest", {
        controller: "Requirement",
        method: "SendRequirementNotification",
        parameters: { requirementId: this.selectedRequirementId },
      });
      this.onCloseModal();
      this.getData();
    },
    async onConfirmReleaseToPortal() {
      await this.$store.dispatch("getRequest", {
        controller: "Portal",
        method: "ReleaseOffers",
        parameters: { id: this.selectedRequirementId },
      });
      this.onCloseModal();
      this.getData();
    },
    exportToPdf(id) {
      this.$refs.pdf.createRequirementPdf(id);
    },
    exportToExcel(id) {
      this.$refs.excel.createRequirementExcel(id);
    },
    offerTemplateExcel(id) {
      this.$refs.excel.createRequirementExcel(id, true);
    },
    async sendAsEmail(id) {
      var result = await this.$store.dispatch("getRequest", {
        controller: "ProjectsApi",
        method: "SendRequirementEmail",
        parameters: { id: id },
      });
      this.$store.commit("setMessage", { title: "Success", type: "info", content: `Please check your email inbox` });
    },
    getClassByStatus(status) {
      if (status == "Open") {
        return "open-chip";
      } else if (status == "Closed") {
        return "closed-chip";
      } else if (status == "Pending" || status == "Expected") {
        return "pending-chip";
      } else if (status == "Cancelled") {
        return "cancelled-chip";
      }
    },
  },
  computed: {
    isMobile: function() {
      return this.$store.state.isMobile;
    },
    missingRowsCount: function() {
      return this.options.itemsPerPage - this.pageData.length;
    },
    editModalVisible() {
      return this.$store.state.requirementModal && this.$store.state.requirementModal.visible;
    },
    activeRequirementId() {
      return this.$store.state.activeRequirementId;
    },
    userRole() {
      return this.$store.state.role;
    },
    noDataMessage() {
      return "There are no requirements to show!";
    },
  },
  mounted: function() {},
  watch: {
    dialogDelete: function() {
      this.options.page = 1;
      this.getData();
    },
    filter: function() {
      this.options.page = 1;
      this.getData();
    },
    options: {
      handler(val) {
        this.getData();
      },
      deep: true,
    },
    showOpen() {
      this.options.page = 1;
      this.getData();
    },
    showClosed() {
      this.options.page = 1;
      this.getData();
    },
    showCancelled() {
      this.options.page = 1;
      this.getData();
    },
  },
};
</script>
<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-btn rounded v-on:click="onAddNew()">Add Requirement<i class="fas fa-plus-circle icon-right"></i></v-btn>
        <v-text-field
          style="float:right"
          hide-details="auto"
          dense
          class="pa-0"
          v-model="filter"
          append-icon="mdi-magnify"
          :label="`Search Requirements`"
          clearable
        ></v-text-field>

        <div style="float:right" class="mr-5 pt-2">
          <v-checkbox label="Open" dense hide-details v-model="showOpen" style="display:inline-block"></v-checkbox>
          <v-checkbox class="ml-2" label="Fixed" dense hide-details v-model="showClosed" style="display:inline-block"></v-checkbox>
          <v-checkbox class="ml-2" label="Cancelled" dense hide-details v-model="showCancelled" style="display:inline-block"></v-checkbox>
        </div>
      </v-col>
    </v-row>
    <v-data-table
      dense
      v-on:click:row="onRowClick"
      :headers="headers"
      :items="pageData"
      class="requirement-table"
      :server-items-length="totalItemCount"
      :options.sync="options"
      :search="filter"
      :loading="loading"
      loading-text="Loading... Please wait"
      :item-class="getItemClass"
      :no-data-text="noDataMessage"
    >
      <template v-slot:item.actions="{ item }">
        <v-menu top offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              <v-icon>
                mdi-dots-vertical
              </v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="onRowEdit(item)">
              <v-list-item-icon>
                <v-icon class="mr-2">
                  mdi-pencil
                </v-icon></v-list-item-icon
              >
              <v-list-item-title>Edit</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onReleaseToPortalClick(item)" v-if="item.OfferCount">
              <v-list-item-icon>
                <v-icon class="mr-2" v-if="!item.OffersReleasedToPortal">
                  mdi-table-eye
                </v-icon>
                <v-icon class="mr-2" v-else>
                  mdi-table-eye-off
                </v-icon></v-list-item-icon
              >
              <v-list-item-title v-if="!item.OffersReleasedToPortal">Release To Portal</v-list-item-title>
              <v-list-item-title v-else>Retract from Portal</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onSendNotificationClick(item)" v-if="item.CanSendNotification">
              <v-list-item-icon>
                <v-icon class="mr-2">
                  mdi-bell
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>Send Notification</v-list-item-title>
            </v-list-item>
            <v-list-item @click="sendAsEmail(item.RequirementId)">
              <v-list-item-icon>
                <v-icon>
                  mdi-email-send
                </v-icon></v-list-item-icon
              >
              <v-list-item-title>Email</v-list-item-title>
            </v-list-item>
            <v-list-item @click="offerTemplateExcel(item.RequirementId)">
              <v-list-item-icon>
                <v-icon>
                  mdi-file-excel
                </v-icon></v-list-item-icon
              >
              <v-list-item-title>Excel Offer Template</v-list-item-title>
            </v-list-item>
            <v-list-item @click="onRowDelete(item)">
              <v-list-item-icon>
                <v-icon>
                  mdi-delete
                </v-icon></v-list-item-icon
              >
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:item.OffersReleasedToPortal="{ item }">
        <v-icon color="success" v-if="item.OffersReleasedToPortal">mdi-check </v-icon>
      </template>
      <template v-slot:item.Status="{ item }">
        <v-chip class="status-chip" :class="getClassByStatus(item.Status)">
          {{ item.Status }}
        </v-chip>
      </template>
    </v-data-table>
    <requirement-modal></requirement-modal>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-text class="subtitle-1 pt-3 text-center">Are you sure you want to permanently delete this requirement?</v-card-text>
        <v-card-actions>
          <v-btn @click="onCloseModal">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onConfirmRowDelete">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogSendNotification" max-width="500px">
      <v-card>
        <v-card-text class="subtitle-1 pt-3 text-center"
          >Are you sure you want to send out a notification for this requirement? Anyone who has the Seabay Mobile App installed will receive this
          notification.</v-card-text
        >
        <v-card-actions>
          <v-btn @click="onCloseModal">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onConfirmSendNotification">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogReleaseToPortal" max-width="500px">
      <v-card>
        <v-card-text class="subtitle-1 pt-3 text-center" v-if="!isRetracting"
          >Are you sure you want to release the offers for this requirement to the Portal? This will be make the offers accessible to all designated
          users.</v-card-text
        >
        <v-card-text class="subtitle-1 pt-3 text-center" v-else
          >Are you sure you want to retract these offers? They may already have been viewed by the charterer.</v-card-text
        >
        <v-card-actions>
          <v-btn @click="onCloseModal">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onConfirmReleaseToPortal">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <pdf-utility ref="pdf"></pdf-utility>
    <excel-utility ref="excel"></excel-utility>
  </div>
</template>
<style scoped>
[class*="status"] {
  font-size: 12px;
}
.table.mobile {
  font-size: 12px;
}
.status-chip {
  margin-left: 2px;
  margin-right: 2px;
}
.open-chip {
  background-color: #4caf67 !important;
  color: white !important;
}
.pending-chip {
  background-color: #ff5b32 !important;
  color: white !important;
}
.cancelled-chip {
  background-color: #f43414 !important;
  color: white !important;
}
.closed-chip {
  background-color: #dbd8d6 !important;
  color: black !important;
}
</style>
